// [AstraChat] Estado compartilhado do "fixar o Jarvis em todas as páginas".
// O ícone dentro do SynapseCopilot liga/desliga; o Dashboard.vue (layout global)
// observa este ref pra montar a barrinha do Jarvis fora da página do Synapse.
// Persistido por conta em localStorage (mesmo padrão do pin do painel).
import { ref } from 'vue';

const KEY = accId => `jarvis_global_${accId || '0'}`;
const globalPinned = ref(false);
let currentAcc = null;

export function loadJarvisGlobalPin(accountId) {
  currentAcc = accountId;
  try {
    globalPinned.value = localStorage.getItem(KEY(accountId)) === '1';
  } catch {
    globalPinned.value = false;
  }
  return globalPinned.value;
}

export function setJarvisGlobalPin(value, accountId) {
  const acc = accountId ?? currentAcc;
  globalPinned.value = !!value;
  try {
    localStorage.setItem(KEY(acc), value ? '1' : '0');
  } catch {
    /* storage pode estar desabilitado */
  }
}

export function useJarvisGlobalPin() {
  return { globalPinned, loadJarvisGlobalPin, setJarvisGlobalPin };
}
